<span class="body-default">
  {{ translation ?? '' | translate }}
</span>
@if (currentBenefit | benefitFlag; as flag) {
  <ui-asset [name]="flag" set="flags" />
}
@if (showTooltip && tooltipText) {
  <ui-product-tooltip [text]="tooltipText" />
}
